import Vue from 'vue'
import store from '@/store'
import {
  LANGUAGE,
  LOCAL_DEFAULT_CONFIG
} from '@/store/mutation-types'

export default function Initializer () {
  const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'
  const localDefaultConfig = Vue.ls.get(LOCAL_DEFAULT_CONFIG) || {}
  store.dispatch('SetLang', lang.replace(/-/, '_'))
  store.dispatch('SetLocalDefaultConfig', {
    appNew: true,
    lite: {},
    ...localDefaultConfig
    // lite: {}
  })
  // document.domain = 'eccang.com'
}
